import script from "./SankeyChartSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SankeyChartSelect.vue?vue&type=script&setup=true&lang=js"

import "./SankeyChartSelect.vue?vue&type=style&index=0&id=2d9719d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9719d0"]])

export default __exports__